<template>
    <Teleport to="body">

        <div class="yps-app yps-overlay">
            
            <div class="overlay"></div>
            <div class="content-wrapper">
                <slot></slot>
                
            </div>

        </div>
    </Teleport>
</template>
